/** Operational settings shared by the admin forms and API validation. */
export const SETTINGS_LIMITS = {
    linkExpiryDays: { min: 1, max: 365 },
    retentionDays: { min: 1, max: 3650 },
    uploadTtlHours: { min: 1, max: 720 },
    maxAttempts: { min: 1, max: 10 },
    backoffMs: { min: 1000, max: 60000 },
    timeoutMs: { min: 1000, max: 120000 },
};
// Each pattern is supported by both the PDF formatter and admin date previews.
export const DATE_FORMAT_OPTIONS = [
    { value: 'dd/LL/yyyy', label: 'Day / month / year (28/09/2026)' },
    { value: 'LL/dd/yyyy', label: 'Month / day / year (09/28/2026)' },
    { value: 'yyyy-LL-dd', label: 'Year-month-day (2026-09-28)' },
    { value: 'd LLL yyyy', label: 'Day month year (28 Sep 2026)' },
    { value: 'd LLLL yyyy', label: 'Day full month year (28 September 2026)' },
];
//# sourceMappingURL=settings.js.map